import { FilterField } from "~/features/filter";
import { INDICATOR_OPTIONS } from "~/pages/Indicators/options";
import { localizedSortFieldForApi } from "~/shared/lib/localizedSortField";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы индикаторов: поле поиска (searchField) и строка
 * поиска (searchText) — оба значения пишутся в URL и уходят в query variables.
 * Локализуемые поля (name, type, unit, period) в английской локали ищут
 * по *En-полям — поведение сохранено со старого ~/components/Filter.
 */
export const indicatorsFilterFields = (
  t: Translate,
  lang: string | null,
): FilterField[] => {
  return [
    {
      name: "searchField",
      type: "select",
      label: t("ui.filter_by"),
      options: INDICATOR_OPTIONS.map((option) => ({
        value: localizedSortFieldForApi(option, lang),
        label: t(`indicators.${option}`),
      })),
    },
    {
      name: "searchText",
      type: "input",
      label: t("ui.search"),
      placeholder: t("ui.search"),
    },
  ];
};
